import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a78a01dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Etes vous sur de vouloir supprimer cette question ?", -1))
const _hoisted_3 = { class: "flex grow" }
const _hoisted_4 = { class: "flex col grow" }
const _hoisted_5 = { class: "flex grow" }
const _hoisted_6 = { class: "panel grow" }
const _hoisted_7 = { class: "flex col" }
const _hoisted_8 = { class: "text-muted bold" }
const _hoisted_9 = { class: "flex align-center justify-between" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeImage = _resolveComponent("SeImage")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_AnswerList = _resolveComponent("AnswerList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      title: "Confirm",
      ref: "removeQuestionModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_SeButton, {
              inverted: true,
              class: "modal-valid grow",
              onPress: _ctx.removeQuestion
            }, {
              default: _withCtx(() => [
                _createTextVNode("Oui")
              ]),
              _: 1
            }, 8, ["onPress"]),
            _createVNode(_component_SeButton, {
              class: "grow",
              onClick: _ctx.abortRemoveQuestion
            }, {
              default: _withCtx(() => [
                _createTextVNode("Non")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      title: _ctx.Lang.getI18N('add'),
      ref: "questionModal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SeInput, {
            style: {"width":"80vw","max-width":"350px"},
            ref: "questionName",
            placeholder: _ctx.Lang.getI18N('name')
          }, null, 8, ["placeholder"]),
          _createVNode(_component_SeButton, {
            onPress: _ctx.addOrModifyQuestion,
            class: "modal-valid w100"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("apply")), 1)
            ]),
            _: 1
          }, 8, ["onPress"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.Lang.getI18N("communication.question-list")), 1),
          _createVNode(_component_SeDropdown, {
            modelValue: _ctx.state.selectedQuestion,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.selectedQuestion) = $event)),
            titleFunc: (question) => question.question,
            ref: "questionSelect"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.selectedSection.quiz!.questions, (question) => {
                return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                  displayTitle: false,
                  value: question
                }, {
                  heading: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", null, _toDisplayString(question.question), 1)
                    ])
                  ]),
                  tailing: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_SeImage, {
                        maxWidth: 18,
                        maxHeight: 18,
                        src: "/ico/trash.svg",
                        onClick: () => _ctx.openRemoveQuestionModal(question)
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_SeImage, {
                        maxWidth: 18,
                        maxHeight: 18,
                        src: "/ico/edit-blue.svg",
                        onClick: () => _ctx.openQuestionModal(question)
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 256)),
              _createVNode(_component_SeDropdownItem, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openQuestionModal())),
                displayTitle: false,
                class: "noselect"
              }, {
                heading: _withCtx(() => [
                  _createElementVNode("span", _hoisted_11, "+ " + _toDisplayString(_ctx.Lang.getI18N("add")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "titleFunc"]),
          (_ctx.state.selectedQuestion != null)
            ? (_openBlock(), _createBlock(_component_AnswerList, {
                key: 0,
                question: _ctx.state.selectedQuestion
              }, null, 8, ["question"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}